<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf="criteriaFormGroup">
    <ng-container [formGroup]="criteriaFormGroup">
        <table class="mat-table" formArrayName="fields">
            <tr class="mat-header-row">
                <th class="mat-header-cell">Field</th>
                <th class="mat-header-cell">Operator</th>
                <th class="mat-header-cell">Search for</th>
                <th class="mat-header-cell">Example</th>
            </tr>
            <tr class="mat-row" [formGroupName]="i"
                *ngFor="let searchField of criteriaFormGroup.get('fields')['controls']; let i=index">

                <td class="mat-cell">
                    <div class='search-row-text'>
                        <div class='search-row-text-item'>{{criteria.fields[i].fieldValue.display}}</div>
                    </div>
                </td>

                <td class="mat-cell">
                    <mat-form-field>
                        <mat-select [formControlName]="criteria.fields[i].operator.name" [compareWith]="compareOpValues">
                            <mat-option *ngFor="let op of criteria.fields[i].operator.operators"
                                        [value]="op.type">{{op.display}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>

                <td class="mat-cell" [ngSwitch]="criteria.fields[i].fieldValue.uitype">

                    <mat-form-field *ngSwitchCase="'input'">
                        <input matInput type="text" [formControlName]="criteria.fields[i].fieldValue.name"/>
                    </mat-form-field>

                    <mat-form-field *ngSwitchCase="'dropdown'">
                        <mat-select [formControlName]="criteria.fields[i].fieldValue.name">
                            <mat-option [value]="undefined">-- Select --</mat-option>
                            <mat-option *ngFor="let opt of criteria.fields[i].fieldValue.listitems"
                                        [value]="opt.value">{{opt.display}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngSwitchCase="'date'">
                        <input matInput
                               [formControlName]="criteria.fields[i].fieldValue.name"
                               [matDatepicker]="dataFormDatePicker">
                        <mat-datepicker-toggle matSuffix [for]="dataFormDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #dataFormDatePicker></mat-datepicker>
                    </mat-form-field>
                </td>

                <td class="mat-cell">
                    <div class='search-row-text'>
                        <button type="button" class="button-link search-row-text-item" (click)="fillFromExample(criteria.fields[i], i)">
                            {{criteria.fields[i].fieldValue.example}}
                        </button>
                    </div>
                </td>
            </tr>
        </table>
        <!--<div><pre>{{criteriaFormGroup.get('fields')|json}}</pre></div>-->
    </ng-container>
</ng-container>
